import React from 'react';
import { getScores } from '../utils/storage';

interface InfoModalProps {
  type: 'daily' | 'upgrade' | 'leaderboard';
  onClose: () => void;
}

export function InfoModal({ type, onClose }: InfoModalProps) {
  const scores = getScores();
  const title = type === 'daily' ? '每日挑战说明' : type === 'upgrade' ? '基础强化系统' : '本地排行榜';
  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <section className="modal" onMouseDown={(event) => event.stopPropagation()} role="dialog" aria-modal="true">
        <div className="modal-header"><h2>{title}</h2><button className="close-btn" onClick={onClose}>×</button></div>
        <div className="modal-body">
          {type === 'daily' && <div className="info-grid">
            <article className="info-item"><h3>固定种子</h3><p>当天所有玩家在同一浏览器日期下获得相同布局，方便后续扩展线上竞赛。</p></article>
            <article className="info-item"><h3>特殊砖块</h3><p>随机混入装甲砖、爆炸砖和奖励砖，使每日地图有变化。</p></article>
            <article className="info-item"><h3>独立记录</h3><p>成绩会标记为“每日挑战”，并保存到当前浏览器的排行榜中。</p></article>
          </div>}
          {type === 'upgrade' && <div className="info-grid">
            <article className="info-item"><h3>⚡ 能量穿透</h3><p>提高每次碰撞伤害，更快击破需要多次撞击的装甲砖。</p></article>
            <article className="info-item"><h3>↔ 扩展挡板</h3><p>永久扩大挡板宽度，降低漏球概率。</p></article>
            <article className="info-item"><h3>🔮 复制核心</h3><p>下一关开始时附加一颗弹球，提升清场效率。</p></article>
          </div>}
          {type === 'leaderboard' && <table className="leaderboard">
            <thead><tr><th>排名</th><th>分数</th><th>模式</th><th>日期</th></tr></thead>
            <tbody>
              {scores.length === 0 && <tr><td colSpan={4}>还没有成绩，先开始一局吧。</td></tr>}
              {scores.map((entry, index) => <tr key={`${entry.date}-${entry.score}-${index}`}><td>#{index + 1}</td><td>{entry.score.toLocaleString()}</td><td>{entry.mode}</td><td>{entry.date}</td></tr>)}
            </tbody>
          </table>}
        </div>
      </section>
    </div>
  );
}
